var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow_chevron_big_left",
    "data-name": "arrow / chevron_big_left",
    d: "M6.857,0,0-7l6.857-7L8-12.833,2.286-7,8-1.167Z",
    transform: "translate(14 8) rotate(-90)",
    fill: "#723e82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp2);
export default __webpack_public_path__ + "static/media/arrowUp2.fd8ae296fc0790eaaf7df476eadabf6b.svg";
export { ForwardRef as ReactComponent };